import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/banner/banner2.png'


const _withScopeId = n => (_pushScopeId("data-v-17a6f22c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "text-banner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-overlay" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.titleBanner), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.textBanner), 1),
      _createVNode(_component_ButtonDefault, {
        msg: "Solicite seu crédito",
        id: "btn-banner",
        onButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToElement('column-two')))
      })
    ]),
    _hoisted_4
  ]))
}